import UseAsAliasModal from './UseAsAliasModal.container'
export default UseAsAliasModal
